module.exports = __webpack_public_path__ + "img/horizontal_1_1_7016.5e1a9b09.png";